export const GLOBAL_VARIABLES_CACHE_KEY = 'APP_GLOBAL_VARIABLES_CACHE'

export const GLOBAL_VARIABLES_EVENT = 'GLOBAL_VARIABLES_EVENT'

